import createSymbol, { createInternalSymbol } from 'lib/core/createSymbol';

const createActivityLogSymbol = createSymbol('ACTIVITYLOG');
const createActivityLogInternalSymbol = createInternalSymbol('ACTIVITYLOG');

export default {
  // Activity Log Table
  FETCH_ACTIVITY_LOGS: createActivityLogSymbol('FETCH_ACTIVITY_LOGS'),
  SET_FETCH_ACTIVITY_LOGS_SUCCESS: createActivityLogSymbol('SET_FETCH_ACTIVITY_LOGS_SUCCESS'),
  SET_FETCH_ACTIVITY_LOGS_FAILURE: createActivityLogSymbol('SET_FETCH_ACTIVITY_LOGS_FAILURE'),
  CLEAR_ACTIVITY_LOGS_STATE: createActivityLogInternalSymbol('CLEAR_ACTIVITY_LOGS_STATE'),

  // cancel call
  CANCEL_ACTIVITY_LOG_SDK_CALL: createActivityLogSymbol('CANCEL_ACTIVITY_LOG_SDK_CALL')
};